import { motion } from 'framer-motion';

const tools = [
  { name: 'Google Calendar', logo: 'https://cdn.simpleicons.org/googlecalendar/white' },
  { name: 'Outlook', logo: 'https://cdn.simpleicons.org/microsoftoutlook/white' },
  { name: 'Salesforce', logo: 'https://cdn.simpleicons.org/salesforce/white' },
  { name: 'HubSpot', logo: 'https://cdn.simpleicons.org/hubspot/white' },
  { name: 'Zapier', logo: 'https://cdn.simpleicons.org/zapier/white' },
  { name: 'Slack', logo: 'https://cdn.simpleicons.org/slack/white' },
  { name: 'Stripe', logo: 'https://cdn.simpleicons.org/stripe/white' },
  { name: 'Zoom', logo: 'https://cdn.simpleicons.org/zoom/white' }
];

export const Integrations = () => {
  return (
    <section className="py-20 bg-brand-base border-t border-brand-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-3xl font-extrabold mb-4 font-display text-white">
          Works With The Tools You <span className="text-brand-primary">Already Use</span>
        </h2>
        <p className="text-slate-400 mb-12 max-w-2xl mx-auto">
          Seamlessly integrates with your calendar, CRM, and payment systems. Don't use any of these? No problem—our system works perfectly standalone.
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-8 md:gap-12 items-center justify-center opacity-70">
           {tools.map((tool, index) => (
             <motion.div 
               key={tool.name}
               initial={{ opacity: 0, y: 10 }}
               whileInView={{ opacity: 1, y: 0 }}
               viewport={{ once: true }}
               transition={{ delay: index * 0.05 }}
               className="flex justify-center grayscale hover:grayscale-0 transition-all duration-300 hover:scale-110"
             >
               <img src={tool.logo} alt={`${tool.name} integration`} className="h-8 md:h-10 w-auto object-contain" title={tool.name} loading="lazy" />
             </motion.div>
           ))}
        </div>
      </div>
    </section>
  );
};
